/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { getRemittances } from "../../store/actions/remittance.action";
import { commissionType, feeCategory } from "../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../utils/services/remittance.service";

function AddNewBrandModal({
  show,
  handleClose,
  domainBrand,
  imtoArr,
  corridorData,
  userId,
}) {
  const dispatch = useDispatch();
  const menuPortalTarget = document.getElementById("root");
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const [corridor, setCorridor] = useState({});
  const [feeCat, setFeeCat] = useState({});
  const [feeType, setFeeType] = useState({});
  const [paycenter, setPaycenter] = useState({});
  const [fee, setFee] = useState(0);
  const [inclusive, setInclusive] = useState(false);
  const [startAmount, setStartAmount] = useState(0);
  const [endAmount, setEndAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const addNewBandRate = async (payload) => {
    setLoading(true);
    try {
      const response = await RemittanceService.addBandRate(payload);
      if (response.data.status === "SUCCESS") {
        dispatch(getRemittances(1, "MONEYTRANSFER", 10));
        toast.success("Band rate added successfully");
        handleClose();
        setCorridor({});
        setFeeCat({});
        setFeeType({});
        setPaycenter({});
        setFee(0);
        setStartAmount(0);
        setEndAmount(0);
        setInclusive(false);
        setLoading(false);
      } else {
        toast.error(response.data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const payload = {
    bottomAmount: parseInt(startAmount),
    topAmount: parseInt(endAmount),
    fee: parseInt(fee),
    rateType: feeType.value || "FLAT",
    superChargeCategory: "MONEYTRANSFER",
    chargeCategory: feeCat.value || "MONEYTRANSFER",
    inclusive: inclusive || true,
    payCenterId: paycenter.value,
    corridorId: corridor.value,
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false}>
      <Modal.Header closeButton={false}>
        <Modal.Title className="fw-bold">
          Add new or modify Fee for Money Transfer
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="needs-validation" onSubmit={(e) => e.preventDefault()}>
          <div className="form-row">
            <div className="col-md-12 col-lg-12 mb-3">
              <label>
                {languageStatus
                  ? dictionary["WO_CORRIDOR_166705112"]
                  : "Corridors"}
              </label>
              <Select
                options={corridorData}
                isClearable={false}
                isSearchable={true}
                maxMenuHeight={250}
                menuPlacement="bottom"
                value={corridor}
                onChange={(option) => {
                  setCorridor(option);
                }}
              />
            </div>

            <div className="col-md-12 col-lg-12 mb-3">
              <div className="row row-sm">
                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["l_charge_category"]
                      : "Fee Category"}
                  </label>
                  <Select
                    options={feeCategory()}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    value={feeCat}
                    onChange={(option) => setFeeCat(option)}
                  />
                </div>
                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["para_charge_type"]
                      : "Fee Type"}
                  </label>
                  <Select
                    options={commissionType}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    value={feeType}
                    onChange={(option) => setFeeType(option)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-12 mb-3">
              <div className="row row-sm">
                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["l_voucher_paycenter"]
                      : "Pay Center"}
                  </label>
                  <Select
                    options={imtoArr}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    value={paycenter}
                    onChange={(option) => setPaycenter(option)}
                  />
                </div>
                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["m_set_remittance_commission"]
                      : "Fee"}
                  </label>
                  <input
                    type={"number"}
                    className="form-control border"
                    value={fee}
                    placeholder=""
                    autoComplete=""
                    onChange={(e) => setFee(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-12 mb-3">
              <div className="row row-sm">
                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["para_starting_amount"]
                      : "Starting Amount"}
                  </label>
                  <input
                    type={"number"}
                    className="form-control border"
                    value={startAmount}
                    placeholder=""
                    autoComplete=""
                    onChange={(e) => setStartAmount(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6">
                  <label>
                    {languageStatus
                      ? dictionary["para_end_amount"]
                      : "End Amount"}
                  </label>
                  <input
                    type={"number"}
                    className="form-control border"
                    value={endAmount}
                    placeholder=""
                    autoComplete=""
                    onChange={(e) => setEndAmount(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-8 mb-3">
              <label>
                {languageStatus
                  ? dictionary["WO_CHARGES_INCLUSIVE_IN_-1545297777"]
                  : " Charges Inclusive in Sending Amount"}
              </label>
              <div className="border py-2 rounded-3" style={{ height: "40px" }}>
                <input
                  type={"checkbox"}
                  className=""
                  onChange={(e) => setInclusive(e.target.checked)}
                />
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>

        <Button
          variant="primary"
          type="button"
          onClick={() => addNewBandRate(payload)}
        >
          {dictionary ? dictionary["button_save_charges"] : "SAVE FEE"}
          &nbsp;&nbsp;
          {loading && <i className="fa fa-spinner fa-spin" />}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddNewBrandModal;
AddNewBrandModal.defaultProps = {
  handleClose: () => {},
  handleSave: () => {},
};

AddNewBrandModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  children: PropTypes.element,
};
